module.exports = __webpack_public_path__ + "images/e1d21cf020e48d887031a11110db44e43cc02adcfb37ecdd98a45e7c455a1b86.svg";